module.exports = __webpack_public_path__ + "img/company_icon.5ffa226e.png";